let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("76bLe")).then(() => parcelRequire('iAFXp'));